import { Field_ClientConfiguredField_Fragment } from '../brief.generated';
import {
    AssociatedPrintProductDropDown,
    AssociatedPrintProductDropDownReview,
} from './ClientConfiguredFields/AssociatedPrintProductDropDown';
import {
    Review as DesignLiveAppointmentReview,
    Input as DesignLiveAppointmentV1Input,
} from './ClientConfiguredFields/DesignLiveAppointmentV1/DesignLiveAppointmentV1Input';
import { ProductDropdown } from './ClientConfiguredFields/ProductDropdown';
import {
    Input as ProductOptionsInput,
    ProductOptionsReview,
} from './ClientConfiguredFields/ProductOptions/ProductOptionsInput';
import {
    ReferenceProjectsInput,
    ReferenceProjectsReview,
} from './ClientConfiguredFields/ReferenceProjects';
import { ClientConfiguredFieldProps } from './ClientConfiguredFields/types';

export function Input(props: ClientConfiguredFieldProps) {
    const { questionId } = props;

    switch (questionId) {
        case 'design-live-appointment-v1':
            return <DesignLiveAppointmentV1Input {...props} />;
        case 'design-live-appointment-v2':
            // This is the same component but the v2 schema is a conditional field
            // so hiding it does not need to be done on the front end
            return <DesignLiveAppointmentV1Input {...props} />;
        case 'care-design-physical-product-v1':
            return <ProductDropdown {...props} />;
        case 'design-physical-product-v1':
            return <AssociatedPrintProductDropDown {...props} />;
        case 'care-design-product-options-v1':
            return <ProductOptionsInput {...props} />;
        case 'reference-projects-v1':
            return <ReferenceProjectsInput {...props} />;
        default:
            throw new Error(`Unknown frontend managed field: ${questionId}`);
    }
}

export function Review(props: Field_ClientConfiguredField_Fragment) {
    const { questionId } = props;

    if (questionId.includes('design-live-appointment')) {
        return <DesignLiveAppointmentReview {...props} />;
    } else if (questionId.startsWith('design-physical-product')) {
        return <AssociatedPrintProductDropDownReview {...props} />;
    } else if (questionId.includes('design-product-options')) {
        return <ProductOptionsReview {...props} />;
    } else if (questionId.includes('reference-projects-v1')) {
        return <ReferenceProjectsReview {...props} />;
    }

    return null;
}
